module.exports = __webpack_public_path__ + "static/media/leaves.ae45039a.svg";